import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid2,
  Link as MuiLink,
  MenuItem,
  TextField,
  Typography,
  CardActions,
  Stack
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';

export default function CreateCourse() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isPending, setIsPending] = useState(false);
  const [availablePrices, setAvailablePrices] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  // const [location, setLocation] = useState('');
  const [gameMode, setGameMode] = useState(2);
  const [extraParams, setExtraParams] = useState('');
  const [gameUrl, setGameUrl] = useState('/fuse/examples/courses/index.html');
  const [price, setPrice] = useState('0');

  const handleGameModeChange = useCallback(async (e) => {
    setGameMode(e.target.value);
  }, []);

  const handleGameUrlChange = useCallback(async (e) => {
    setGameUrl(e.target.value);
  }, []);

  const handleFormSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsPending(true);
    const payload = {
      title,
      price,
      description,
      gameMode,
      gameUrl,
      extraParams
    };
    console.log(payload);
    try {
      const response = await auth.request('/api/developer/create', payload)
      console.log(response);
      if (!response.data?.course?._id) {
        console.error('Unable to create new course!');
        return;
      }
      navigate(`../edit/${response.data.course._id}`);
    } catch (error) {
      console.log(error);
    } finally {
      setIsPending(true);
    }

  }, [auth, navigate, title, description, price, gameMode, gameUrl, extraParams]);

  const fetchPrices = useCallback(async () => {
    setIsLoading(true);
    const response = await auth.request('/api/developer/prices');
    if (response.data.prices) {
      setAvailablePrices(response.data.prices);
      setPrice(response.data.prices[0]);
    }
    setIsLoading(false);
  }, [auth]);

  useEffect(() => {
    console.log('gameMode change', gameMode);
    switch (gameMode) {
      case 0: {
        setGameUrl('/fuse/examples/range/index.html');
        break;
      }
      case 2: {
        setGameUrl('/fuse/examples/courses/index.html');
        break;
      }
      default:
        setGameUrl('');
        break;
    }
  }, [gameMode]);

  useEffect(() => {
    fetchPrices();
    return () => {
      console.log('canceled');
    }
  }, []);

  if (isLoading) {
    return null;
  }
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Breadcrumbs>
        <MuiLink component={Link} to="/account/developer/">Courses</MuiLink>
        <Typography>Create Course</Typography>
      </Breadcrumbs>

      <form onSubmit={handleFormSubmit}>
        <Card sx={{ mt: 3 }}>
          <CardHeader title="Course Details" />
          <CardContent sx={{ pt: 3 }}>
            <Stack spacing={3} direction="column">
              <Box>
                <TextField
                  disabled={isPending}
                  label="Title"
                  fullWidth={true}
                  required={true}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Box>

              <Box>
                <TextField
                  disabled={isPending}
                  label="Course Type"
                  select={true}
                  fullWidth={true}
                  value={gameMode}
                  onChange={handleGameModeChange}
                >
                  <MenuItem value={0}>Practice Range</MenuItem>
                  <MenuItem value={1}>Custom Game</MenuItem>
                  <MenuItem value={2}>Golf Course</MenuItem>
                </TextField>
              </Box>
                            
              <Box>
                <TextField
                  label="Custom URL"
                  fullWidth={true}
                  disabled={isPending || gameMode===2}
                  value={gameUrl}
                  onChange={handleGameUrlChange}
                />
              </Box>
              
              <Box>
                <TextField
                  disabled={isPending}
                  label="Extra Params"
                  fullWidth={true}
                  placeholder="practiceMode=ladder"
                  value={extraParams}
                  onChange={(e) => setExtraParams(e.target.value)}
                />
              </Box>
              <Box>
                <TextField
                  disabled={isPending}
                  label="Price"
                  select={true}
                  fullWidth={true}
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                >
                  <MenuItem value="0">FREE</MenuItem>
                  {availablePrices?.length ? availablePrices.map(price => (
                    <MenuItem key={price} value={price}>${price}</MenuItem>
                  )) : null}
                </TextField>
              </Box>
              <Box>
                <TextField
                  disabled={isPending}
                  onChange={(e) => setDescription(e.target.value)}
                  label="Description"
                  multiline={true}
                  rows={3}
                  fullWidth
                />
              </Box>
            </Stack>
          </CardContent>
          <CardActions sx={{ mt: 2 }}>
            <Button
              component={Link}
              to="/account/developer/"
              color="secondary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isPending} color="primary" variant="outlined">
              Create Course
            </Button>
          </CardActions>
        </Card>
      </form>
    </Box>
  );
}